import Vue from 'vue';
import axios from 'axios';
import _xor from 'lodash/xor';
import _find from 'lodash/find';
import { auth } from '../utils/requests';
import { request_mutations, request_state } from '../utils/store';
import { COLUMN_LIST, COLUMN_DETAIL } from '../api';

export default {
    namespaced: true,
    state: {
        collapsed_columns: {},
        list: request_state(),
        create: request_state(),
        update: request_state(),
        remove: request_state(),
    },
    mutations: {
        ...request_mutations('list', 'list'),
        ...request_mutations('create', 'create'),
        ...request_mutations('update', 'update'),
        ...request_mutations('remove', 'remove'),
        move_column(state, { from, to }) {
            const column = state.list.data.results[from];
            state.list.data.results.splice(from, 1);
            state.list.data.results.splice(to, 0, column);
            column.position = to;
        },
        update_column(state, { id, name, color }) {
            const column = _find(state.list.data.results, { id });
            column.color = color;
            column.name = name;
        },
        toggle_column(state, { flow_id, column_id }) {
            const columns = state.collapsed_columns[flow_id] || [];
            Vue.set(state.collapsed_columns, flow_id, _xor(columns, [column_id]));
        },
    },
    actions: {
        list({ commit }, { space_id, flow_id }) {
            const url = COLUMN_LIST
                .replace('{space_id}', space_id)
                .replace('{flow_id}', flow_id);

            commit('list_loading');
            axios.get(url, auth()).then((response) => {
                commit('list_success', response.data);
            }).catch((error) => {
                commit('list_error', error.response ? error.response.data : {});
            });
        },
        create({ commit }, { space_id, flow_id, data }) {
            const url = COLUMN_LIST
                .replace('{space_id}', space_id)
                .replace('{flow_id}', flow_id);

            commit('create_loading');
            return new Promise((resolve) => {
                axios.post(url, data, auth()).then((response) => {
                    commit('create_success', response.data);
                    resolve();
                }).catch((error) => {
                    commit('create_error', error.response ? error.response.data : {});
                });
            });
        },
        update({ commit }, {
            space_id, flow_id, column_id, data,
        }) {
            const url = COLUMN_DETAIL
                .replace('{space_id}', space_id)
                .replace('{flow_id}', flow_id)
                .replace('{column_id}', column_id);

            commit('update_loading');
            return new Promise((resolve) => {
                axios.patch(url, data, auth()).then((response) => {
                    commit('update_success', response.data);
                    resolve(response.data);
                }).catch((error) => {
                    commit('update_error', error.response ? error.response.data : {});
                });
            });
        },
        remove({ commit }, { space_id, flow_id, column_id }) {
            const url = COLUMN_DETAIL
                .replace('{space_id}', space_id)
                .replace('{flow_id}', flow_id)
                .replace('{column_id}', column_id);

            commit('remove_loading');
            return new Promise((resolve) => {
                axios.delete(url, auth()).then((response) => {
                    commit('remove_success', response.data);
                    resolve();
                }).catch((error) => {
                    commit('remove_error', error.response ? error.response.data : {});
                });
            });
        },
    },
};
